export default __webpack_public_path__ + "static/media/clock.e05c6d99.svg";